import { MixedObject } from '@core/interfaces/mixed-object';
import { BlockTypeEnum } from '@core/enums';
import { Block } from '@core/models/block/block.model';

export function blockStyleMinWidth(blockStyles: MixedObject): string {
  if (!blockStyles) {
    return '';
  }
  const width: string = blockStyles?.basic?.width || '';
  if (!width || typeof width === 'number' || width.endsWith('%')) {
    return '';
  }
  return width;
}

export function blockStyleWidth(item: Block, blockStyles: MixedObject): string {
  if (!item.styles) {
    return '';
  }
  const width: string = blockStyles?.basic?.width || '';
  return !width && item.specialBlock
  && [
    BlockTypeEnum.INVENTORIES_LIST_TYPE_WWW,
    BlockTypeEnum.EXHIBITIONS_LIST_TYPE,
    BlockTypeEnum.NEWS_LIST_TYPE,
    BlockTypeEnum.ARTISTS_LIST_TYPE_WWW,
  ].includes(item.specialBlockType)
    ? '100%'
    : (width || '');
}
